import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { toast } from 'sonner';
import { CheckCircle2, LogOut } from 'lucide-react';

const STATUS_LABEL = {
  disconnected: 'Desconectado',
  qr: 'Aguardando leitura do QR Code',
  connecting: 'Conectando...',
  ready: 'Conectado',
  offline: 'Serviço indisponível no momento',
  error: 'Erro ao consultar status',
};

export default function Whatsapp() {
  const [wa, setWa] = useState({ status: 'disconnected', ready: false, qr: null });
  const [loading, setLoading] = useState(true);
  const [loggingOut, setLoggingOut] = useState(false);
  const pollRef = useRef(null);

  const carregar = () => {
    api.get('/whatsapp/status')
      .then(res => setWa(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    // /connect é o gatilho real de pareamento (cria a sessão sob demanda);
    // as próximas checagens usam /status, que só lê o estado já existente.
    api.post('/whatsapp/connect')
      .then(res => setWa(res.data))
      .catch(() => toast.error('Erro ao conectar WhatsApp'))
      .finally(() => setLoading(false));
    pollRef.current = setInterval(carregar, 4000);
    return () => clearInterval(pollRef.current);
  }, []);

  const desconectar = async () => {
    setLoggingOut(true);
    try {
      await api.post('/whatsapp/logout');
      toast.success('WhatsApp desconectado.');
      carregar();
    } catch {
      toast.error('Erro ao desconectar WhatsApp');
    } finally {
      setLoggingOut(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <div className="w-7 h-7 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-5 animate-fade-in">
      <div>
        <h1 className="font-heading text-2xl font-bold text-white">WhatsApp</h1>
        <p className="text-sm text-zinc-500 mt-1">
          Conecte o WhatsApp da sua empresa para enviar e receber avisos de agendamento com o seu próprio número.
          Sem conectar, os agendamentos continuam funcionando normalmente, só não são notificados por WhatsApp.
        </p>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 max-w-md">
        {wa.ready ? (
          <div className="flex flex-col items-center gap-4 py-6 text-center">
            <CheckCircle2 size={48} className="text-green-500" />
            <div>
              <p className="text-white font-semibold">WhatsApp conectado</p>
              <p className="text-sm text-zinc-500 mt-1">Seu número está pronto para enviar e receber avisos.</p>
            </div>
            <button
              onClick={desconectar}
              disabled={loggingOut}
              className="flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 disabled:opacity-50 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
            >
              <LogOut size={16} />
              {loggingOut ? 'Desconectando...' : 'Desconectar'}
            </button>
          </div>
        ) : wa.qr ? (
          <div className="flex flex-col items-center gap-4 py-2 text-center">
            <img src={wa.qr} alt="QR Code do WhatsApp" className="w-64 h-64 rounded-lg bg-white p-2" />
            <p className="text-sm text-zinc-400">
              Abra o WhatsApp no celular da empresa → Aparelhos Conectados → Conectar aparelho, e escaneie o código acima.
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3 py-10 text-center">
            <div className="w-7 h-7 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-zinc-500">{STATUS_LABEL[wa.status] || wa.status}</p>
          </div>
        )}
      </div>
    </div>
  );
}
